module.exports = __webpack_public_path__ + "static/img/tedian2.4bfa6f01.png";